import { atom } from 'jotai'

/**
 * 荷姿マスタのインポートModalの表示状態
 */
export const isOpenPackageCategoryImportModalAtom = atom<boolean>(false)

isOpenPackageCategoryImportModalAtom.debugLabel =
  'isOpenPackageCategoryImportModalAtom'
